import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "../../../../utils/axios/requestInfo";

import { api } from "../../../../resources/api";
import { getSendCodeErrorMessage } from "../../../../helpers/sendCodeError";
import { FormNames } from "../../../../resources/constants";
import { setToken, setPhoneData } from "../../../auth/slice";
import { setPartnerId } from "../../../user/slice";

import {ICodeResp, IFetchCodeArgs, IFetchPassArgs, IFetchReqCodeArgs} from "./types";

export const fetchSendPhone = createAsyncThunk<string, { phone: string }, { rejectValue: string }>(
  "changePass/fetchSendPhone",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(api.profile.settings.changePass.SEND_PHONE, data);

      if (response.status === 200 && response.statusText === "OK") {
        return FormNames.MESSAGE;
      } else {
        return FormNames.ERROR;
      }
    } catch (error: any) {
      const errorMessage = error.response?.data?.message || error.message || "Ошибка отправки запроса";
      const clearPhone = `+${data.phone.replace(/\D/g, '')}`;
      
      if (errorMessage === 'Not allowed' || errorMessage.includes('Not allowed')) {
        return rejectWithValue('В данный момент сервис недоступен, просьба повторить попытку через 1 минуту');
      } else if (errorMessage.includes(`Phone number ${clearPhone} is not registered`) || 
                 errorMessage.includes('is not registered') ||
                 errorMessage.includes('not registered')) {
        return rejectWithValue('Пользователь с таким номером не зарегистрирован');
      } else if (error.response?.status === 422) {
        return rejectWithValue(errorMessage);
      } else {
        return rejectWithValue(getSendCodeErrorMessage(error.response?.data?.message));
      }
    }
  }
);

export const fetchSendCode = createAsyncThunk<ICodeResp, IFetchCodeArgs, { rejectValue: string }>(
  "changePass/fetchSendCode",
  async (data, { dispatch, rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(api.profile.auth.CONFIRM_RESTORE, {
        phone: data.phone,
        code: data.code,
      });
      
      if (response.status === 200 || response.status === 201) {
        const responseData = response.data?.data || response.data;
        const { access_token, partner_id } = responseData;
        
        if (access_token) {
          dispatch(setToken(access_token));
          dispatch(setPhoneData(data.phone));
          if (partner_id) {
            dispatch(setPartnerId(partner_id));
          }
        }
        
        return { form: FormNames.PASSWORD, token: access_token || "" };
      } else {
        return rejectWithValue("Ошибка подтверждения кода");
      }
    } catch (error: any) {
      const errorMessage = error.response?.data?.message || 
                         error.response?.data?.error || 
                         error.message || 
                         "Ошибка подтверждения кода";
      
      if (errorMessage.includes("expired") || errorMessage.includes("истек") || errorMessage.includes("expired")) {
        return rejectWithValue("Время действия кода истекло. Запросите новый код.");
      } else if (errorMessage.includes("invalid") || errorMessage.includes("неверн") || errorMessage.includes("Invalid")) {
        return rejectWithValue("Неверный код подтверждения");
      } else if (error.response?.status === 400) {
        return rejectWithValue(errorMessage);
      } else if (error.response?.status === 422) {
        return rejectWithValue(errorMessage);
      } else {
        return rejectWithValue("Ошибка подтверждения кода. Попробуйте позже.");
      }
    }
  }
);

export const fetchSendRegCode = createAsyncThunk<ICodeResp, IFetchCodeArgs>(
    "changePass/fetchSendCode",
    async (data, { dispatch }) => {
        try {
            const response = await axiosInstance.post(api.profile.auth.CONFIRM, {
                phone: data.phone,
                code: data.code,
            });
            
            if (response.status === 200 || response.status === 201) {
                const responseData = response.data?.data || response.data;
                const { access_token, partner_id } = responseData;
                
                if (access_token) {
                    dispatch(setToken(access_token));
                    dispatch(setPhoneData(data.phone));
                    if (partner_id) {
                        dispatch(setPartnerId(partner_id));
                    }
                }
                
                return { form: FormNames.MESSAGE, token: access_token || "" };
            }
            else{
               return { form: FormNames.ERROR, token: "" };
            }

        } catch (error: any) {
            return error.response?.status === 422
                ? { form: FormNames.ERROR_CODE, token: "" }
                : { form: FormNames.ERROR, token: "" };
        }
    }
);

export const fetchSendNewPassword = createAsyncThunk<string, IFetchPassArgs, { rejectValue: string }>(
  "changePass/fetchSendNewPassword",
  async (data, { dispatch, rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(api.profile.auth.NEW_PASSWORD, {
        phone: data.phone,
        password: data.password,
      });

      if (response.status === 200 || response.status === 201) {
        const responseData = response.data?.data || response.data;
        const { access_token, partner_id } = responseData;
        
        if (access_token) {
          dispatch(setToken(access_token));
          dispatch(setPhoneData(data.phone));
          if (partner_id) {
            dispatch(setPartnerId(partner_id));
          }
        }
        
        return FormNames.PASSWORD_APPLY;
      } else {
        return rejectWithValue("Ошибка установки нового пароля");
      }
    } catch (error: any) {
      const errorMessage = error.response?.data?.message || error.message || "Ошибка установки нового пароля";
      return rejectWithValue(errorMessage);
    }
  }
);
